<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <div>
        <br>
        <v-btn
          class="mx-2"
          dark
          small
          color="success"
          @click="
            $router.push({
              name: 'Home',
            })
          "
        >
          Menú
        </v-btn>
        <br>
        <br>
      </div> -->
      <v-dialog v-model="showInactiveModal" max-width="500">
          <v-card>
            <v-card-title class="text-h5 justify-center modal-info" style="color: white">
              Conversación Inactiva
              <v-spacer></v-spacer>
              <v-btn icon dark @click="handleNo">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <p>Esta conversación ha estado inactiva. ¿Desea finalizar la conversación?</p>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="justify-space-around">
              <v-btn color="blue darken-1" text @click="handleNo" small>
                No
              </v-btn>
              <v-btn color="red darken-1" text @click="handleYes" small>
                Sí
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <v-row no-gutters style="max-height: 100vh; background-color: #F5F4F7; margin: 0px 0px 10px 20px;">

        <!-- Menú Lateral -->
        <v-col class="bg-light " v-if="showMenu" :class="{ 'col-2': $vuetify.breakpoint.smAndDown, 'col-md-2': $vuetify.breakpoint.mdAndUp }">
          
          <p style="font-size: 20px; padding: 20px 20px 0px 20px">Bandeja</p>
          <p style="font-size: 14px; padding-left: 20px">CONVERSACIONES</p>
          <p style="padding-left: 20px;">
            <i
              id="powerButton"
              class="mdi mdi-power mdi-36px"
              style="cursor: pointer; transition: transform 0.3s, box-shadow 0.3s, border 0.3s, background-color 0.3s; border: 1px solid #ccc; border-radius: 6px; display: inline-block; width: 36px; height: 36px; line-height: 36px; text-align: center;"
              :style="{ color: buttonColor, boxShadow: isButtonPressed ? '0 0 10px rgba(0, 0, 0, 0.5) inset' : '0 0 10px rgba(0, 0, 0, 0.1)', transform: isButtonPressed ? 'scale(0.95)' : 'scale(1)', backgroundColor: isButtonPressed ? '#f0f0f0' : (buttonColor === 'green' ? '#9effa9' : 'transparent') }"
              @click="operatorStatus"
              @mousedown="pressButton"
              @mouseup="releaseButton"
              @mouseleave="releaseButton"
            ></i>
          </p>
          <v-divider class="mb-6"></v-divider>

          <v-row align="center" style="padding-left: 20px; margin-right: 20px;">
            <v-list-item
              v-on:click="selectMenuItem(1)"
              class="d-flex align-center justify-space-between"
            >
              <v-list-item-title>
                Tu
              </v-list-item-title>
              <v-badge color="#DB1D4A" :content="countTu > 0 ? countTu : '0'"></v-badge>
            </v-list-item>

            <v-list-item 
              class="d-flex align-center justify-space-between" 
              v-on:click="selectMenuItem(2)"
            >
              <v-list-item-title>
                Asignado a otros
              </v-list-item-title>
              <v-badge color="#DB1D4A" :content="countOtros > 0 ? countOtros : '0'"></v-badge>
            </v-list-item>

            <v-list-item 
              class="d-flex align-center justify-space-between"
              v-on:click="selectMenuItem(3)"
            >
              <v-list-item-title>
                Todo 
              </v-list-item-title>
              <v-badge color="#DB1D4A" :content="countTodo > 0 ? countTodo : '0'"></v-badge>
            </v-list-item>
          </v-row>
          <div style="margin-top: 10%; " >
            <p style="font-size: 14px; padding-left: 20px;">COMPAÑEROS</p>

            <v-text-field
              v-model="textSearchContact"
              label="Buscar compañeros"
              @input="textSearchContact ? searchOperadores() : ''"
              style="padding-left: 7%; padding-right: 7%;"
            >
            </v-text-field>
            <!-- seccion compañeros -->
            <v-col style="max-height: 30vh; margin-top:5px; padding-left: 20px;" class="overflow-y-auto">
              <div v-for="(companero, index) in (textSearchContact ? operadorEncontrado : companeros)" :key="index" style="margin-top: 10%; margin-right: 15px;" 
                class="d-flex align-center justify-space-between" 
              > 
                <p style="margin-bottom: 0px; padding-right: 15px;"  @click="getChatsCompanero(companero.id)">{{ companero.nombre }}</p>
                <v-badge color="#DB1D4A" :content="companero.countChatsAsignados > 0 ? companero.countChatsAsignados : '0'"> 
                </v-badge>
              </div>
            </v-col>
          </div>
        </v-col>

        <!-- Panel de Chats -->
        <v-col v-if="showChatPanel" style="background-color: white;" :class="{ 'col-3': $vuetify.breakpoint.smAndDown, 'col-md-3': $vuetify.breakpoint.mdAndUp }">
          <p style="font-size: 20px; padding: 20px 0px 0px 20px;">

            Todo
          </p>
          
          <v-col class="overflow-y-auto" style="max-height: 67vh" cols="12">
          <v-row v-for="chat in getSelectedOptionChats()" :key="chat.chatGptId" @click="() => {
              chatFocused = chat;
              getSelectedChat(chat, chat.ultimo_mensaje_visto == 1 ? false : true);
          }">
              <v-col class="d-flex align-center">
                  <!-- Foto de perfil -->
                  <v-list-item-avatar class="mr-2">
                      <v-img :src="chat.imagen" v-if="chat.imagen" style="cursor: pointer"></v-img>
                      <v-img v-else style="background-color: #8FC6DC; cursor: pointer">
                          <v-icon color="#fff">mdi-account</v-icon>
                      </v-img>
                  </v-list-item-avatar>
                  <v-col style="margin-top:10px; padding-left: 20px;">
                      <v-row class="d-flex align-left justify-space-between">
                          <div style="display: flex; align-items: center;">
                              <span style="cursor: pointer; margin-right: 8px;" :style="!chat.ultimo_mensaje_visto && 'font-weight: bold;'">{{ chat.alumno }}</span>
                              <v-badge v-if="chat.inactivo" color="orange" overlap style="margin-left: 10px; margin-top: -5px;">
                                  <span slot="badge">{{ chat.inactiveMessage }}</span>
                              </v-badge>
                          </div>
                          <div>
                              <span style="font-size: 65%; margin-left: 20px;" class="text-right">{{ chat.horaUltimoMensaje }}</span>
                          </div>
                      </v-row>
                      <v-row>
                          <span style="font-size: 65%; margin-right: 20%; cursor: pointer;">{{ chat.ultimoMensaje }}</span>
                      </v-row>
                  </v-col>
              </v-col>
          </v-row>
          </v-col>
        </v-col>

        <!-- Conversaciones-->
        <v-col :class="{ 'col-12': $vuetify.breakpoint.smAndDown, 'col-md-7': $vuetify.breakpoint.mdAndUp }">
          <v-row v-if="selectedChatData">
            <v-card-text>
                      <v-col class="d-flex align-center" style="margin-top: -10px; margin-bottom: -10px">
                        <!-- Foto de perfil -->
                <v-list-item-avatar class="mr-2">
                  <v-img :src="selectedChatData.imagen" v-if="selectedChatData.imagen"></v-img>
                  <v-img v-else style="background-color: #8FC6DC;">
                    <v-icon color="#fff">mdi-account</v-icon>
                  </v-img>
                </v-list-item-avatar>
                <div style="display: flex; flex-direction: column;">
                  <span class="mr-2" style="font-size: 130%; margin-bottom: 5px;">{{ selectedChatData.alumno }}</span>
                    <a :href="(debug ? 'http://localhost:8001/' : 'https://sistemaiea.com/') + 'alumnos.legajo.ver.php?editar_por_id=' + this.alumnoId + '&t='+ this.$store.getters.token.substring(7) " target="_blank" style="font-size: 80%;">
                      Toque aquí para ver la información
                    </a>
                </div>
                
                <div class="ml-auto" v-if="this.selectedOption == 1">
                  <v-select
                    v-model="selectedOperador"
                    :items="operadoresDisponibles"
                    item-text="nombre"
                    item-value="id"
                    label="Reasignar conversación a"
                    persistent-hint
                    return-object
                    single-line
                    class="align-self-end"
                    style="min-width: 200px;"
                    @change="dialogReasignar = true"
                  ></v-select>
                </div>
                <div @click="onDisconect" class="ml-auto" style="border-radius: 20px; display: flex; background-color: rgb(219, 29, 74); margin-left: 10vw; align-items: center; padding: 0.8vw 1vw; justify-content: center; cursor: pointer;" v-if="selectedOption == 1">
                  <p style="display: inline; text-align: center; margin: 0; color: white; font-weight: bold;">Finalizar</p>
                </div>
              </v-col>
              
              <v-col ref="allChatSelected" style="max-height: 52vh; background-color: #fbfafb;" class="overflow-y-auto" cols="12">
                <div v-for="(msg, index) in allChatSelected" :key="index">
                  <p>
                    

                   
                    <v-card
                      color="transparent"
                      class="d-flex justify"
                      flat
                      tile
                      v-if="msg.file && msg.user_message"
                    >
                      <a
                        style="text-decoration: none"
                        :href="msg.file"
                        :download="msg.filename"
                        target="_blank"
                      >
                        <v-sheet
                          color="white"
                          elevation="1"
                          width="100"
                          class="m-10 p-5 preview"
                          rounded
                          style="
                            text-align: center;
                            display: block;
                            margin: 10px 0;
                          "
                        >
                          <v-img
                            :src="msg.file"
                            width="100"
                            v-if="msg.type == 'image'"
                          ></v-img>
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="#FFDB58"
                            v-if="msg.type && msg.type.match('image.*')"
                          >mdi-file-image</v-icon>

                          <v-icon
                            class="mt-5"
                            size="50"
                            color="red"
                            v-if="msg.type && msg.type.match('pdf.*')"
                          >mdi-file-pdf-box</v-icon>
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="green"
                            v-if="msg.type && msg.type.match('excel.*')"
                          >mdi-file-excel</v-icon>
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="blue"
                            v-if="msg.type && msg.type.match('word.*')"
                          >mdi-file-word</v-icon>
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="orange"
                            v-if="msg.type && msg.type.match('presentation.*')"
                          >mdi-file-powerpoint</v-icon>
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="purple"
                            v-if="msg.type && msg.type.match('video.*')"
                          >mdi-file-video</v-icon>
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="darken"
                            v-if="
                              !msg.type ||
                              ( !msg.type.match('pdf.*') &&
                                !msg.type.match('image.*') &&
                                !msg.type.match('excel.*') &&
                                !msg.type.match('word.*') &&
                                !msg.type.match('presentation.*') &&
                                !msg.type.match('video.*'))
                            "
                          >mdi-file</v-icon>
                          <div style="display: flex; flex-direction: column; align-items: center; margin-top: 5px; max-width: 120px;">
                            <p style="margin-top: 5px; overflow: hidden; text-overflow: ellipsis; max-width: 90px;">{{ msg.filename }}</p>
                          </div>



                        </v-sheet>
                      </a>
                    </v-card>
                 



                    <v-card
                      color="transparent"
                      class="d-flex justify-start"
                      flat
                      tile
                    >
                      <v-card
                        color="white"
                        style="border-radius: 10px 10px 0px;"
                        :elevation="1"
                        class="pa-2 mr-1"
                        v-if="
                          msg.user_message  && msg.user_message.trim !== ''
                        "
                        v-html="msg.user_message "
                      >
                      </v-card>
                    </v-card>

                      <v-card
                        color="transparent"
                        class="d-flex justify-start mb-6 mr-1"
                        flat
                        tile
                        v-if="
                          msg.user_message  && msg.user_message.trim !== ''
                        "
                      >
                        <small
                          class="mt-2"
                          style="font-size: 0.6rem; color: grey"
                          >{{ msg.hora + ' - ' + nombreAlumno}}
                        </small>
                      </v-card>
                    </p>
                    <p>
                      <v-card
                        color="transparent"
                        class="d-flex justify-end"
                        flat
                        tile
                        v-if="msg.file && msg.chatgpt_response"
                      >
                        <a
                          style="text-decoration: none"
                          :href="msg.file"
                          :download="msg.filename"
                          target="_blank"
                        >
                          <v-sheet
                            color="#d5ecf5"
                            elevation="1"
                            width="100"
                            class="m-10 p-5 preview"
                            rounded
                            style="
                              text-align: center;
                              display: block;
                              margin: 10px 0;
                            "
                          >
                            <v-img
                              :src="msg.file"
                              width="100"
                              v-if="msg.type == 'image'"
                            ></v-img>
                            <v-icon
                              class="mt-5"
                              size="50"
                              color="#FFDB58"
                              v-if="msg.type && msg.type.match('image.*')"
                            >mdi-file-image</v-icon>

                            <v-icon
                              class="mt-5"
                              size="50"
                              color="red"
                              v-if="msg.type && msg.type.match('pdf.*')"
                            >mdi-file-pdf-box</v-icon>
                            <v-icon
                              class="mt-5"
                              size="50"
                              color="green"
                              v-if="msg.type && msg.type.match('excel.*')"
                            >mdi-file-excel</v-icon>
                            <v-icon
                              class="mt-5"
                              size="50"
                              color="blue"
                              v-if="msg.type && msg.type.match('word.*')"
                            >mdi-file-word</v-icon>
                            <v-icon
                              class="mt-5"
                              size="50"
                              color="orange"
                              v-if="msg.type && msg.type.match('presentation.*')"
                            >mdi-file-powerpoint</v-icon>
                            <v-icon
                              class="mt-5"
                              size="50"
                              color="purple"
                              v-if="msg.type && msg.type.match('video.*')"
                            >mdi-file-video</v-icon>
                            <v-icon
                              class="mt-5"
                              size="50"
                              color="darken"
                              v-if="
                                !msg.type ||
                                ( !msg.type.match('pdf.*') &&
                                  !msg.type.match('image.*') &&
                                  !msg.type.match('excel.*') &&
                                  !msg.type.match('word.*') &&
                                  !msg.type.match('presentation.*') &&
                                  !msg.type.match('video.*'))
                              "
                            >mdi-file</v-icon>
                            <div style="display: flex; flex-direction: column; align-items: center; margin-top: 5px; max-width: 120px;">
                              <p style="margin-top: 5px; overflow: hidden; text-overflow: ellipsis; max-width: 90px;">{{ msg.filename }}</p>
                            </div>

    
    
                          </v-sheet>
                        </a>
                      </v-card>
                      <v-card
                      color="transparent"
                      class="d-flex justify-end"
                      flat
                      tile
                    >
                      <v-card
                        color="#d5ecf5"
                        :elevation="1"
                        text-color="#616161"
                        class="pa-2 mb-2"
                        style="border-radius: 10px 10px 10px 0px"
                        v-if="
                          msg.chatgpt_response && msg.chatgpt_response.trim !== ''
                        "
                        v-html="msg.chatgpt_response"
                      >
                    </v-card>
                  </v-card>
                  <v-card
                  color="transparent"
                  class="d-flex justify-end ml-3"
                  
                  flat
                  tile
                  v-if="
                          msg.chatgpt_response && msg.chatgpt_response.trim !== ''
                        "
                    >
                      <small
                        style="font-size: 0.6rem; color: grey"
                      >
                        {{ msg.hora + ' - ' + msg.operator_name}} 
                      </small> 
                    </v-card>
                  </p>
                </div>
              </v-col>
            </v-card-text>
            <v-card-text style="padding: 0px 10px 0px 30px;">
              <v-text-field
                  v-model.trim="messageForm.content"
                  :label="
                    sendingMessage
                      ? 'Enviando mensaje...'
                      : 'Escribe un mensaje'
                  "
                  type="text"
                  no-details
                  :disabled="sendingMessage"
                  outlined
                  prepend-icon="mdi-emoticon"
                  :append-outer-icon="
                    messageForm.content ? 'mdi-send' : 'mdi-attachment'
                  "
                  @keyup.enter="addMessage(messageForm.content,chatId)"
                  @click:append-outer="
                    messageForm.content
                      ? addMessage(messageForm.content,chatId)
                      : attachFile();
                  "                         
                  @click:prepend="showEmojis = !showEmojis"
                  @click="showEmojis = false"
                  @focus="showEmojis = false"
                  hide-details
                  clear-icon="mdi-close-circle"
                  clearable
                />
            </v-card-text>
            <template>
              <v-dialog v-model="showImageAttach" max-width="825" scrollable>
                <v-card>
                  <v-card-title
                    class="text-h5 justify-center modal-info"
                    style="color: white"
                  >
                    Adjuntar archivo
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="hiddeAttachDialog()">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-card-text>
                    <v-alert outlined dense type="info" class="mt-2">
                      <small
                        >Tamaño máximo por archivo
                        <strong>{{ max_size_file }}MB</strong></small
                      >
                    </v-alert>
                    <p>
                      <v-row class="mt-2">
                        <div
                          v-for="(file, index) in messageForm.files"
                          :key="index"
                          style="text-align: center"
                        >
                          <v-chip
                            class="ma-4"
                            close
                            color="#f2f2f2"
                            close-icon="mdi-delete"
                            text-color="blue"
                            @click:close="deleteFileChatThumnail(index)"
                          >
                            <v-sheet
                              color="white"
                              elevation="1"
                              height="100"
                              width="100"
                              class="m-10 p-5 preview"
                            >
                              <div style="text-align: center">
                                <img
                                  :src="file.url"
                                  v-if="file.type.match('image.*')"
                                />
                                <v-icon
                                  class="mt-5"
                                  size="50"
                                  color="red"
                                  v-if="file.type.match('pdf.*')"
                                  >mdi-file-pdf-box</v-icon
                                >
                                <v-icon
                                  class="mt-5"
                                  size="50"
                                  color="green"
                                  v-if="file.type.match('excel.*')"
                                  >mdi-file-excel</v-icon
                                >
                                <v-icon
                                  class="mt-5"
                                  size="50"
                                  color="blue"
                                  v-if="file.type.match('word.*')"
                                  >mdi-file-word</v-icon
                                >
                                <v-icon
                                  class="mt-5"
                                  size="50"
                                  color="orange"
                                  v-if="file.type.match('presentation.*')"
                                  >mdi-file-powerpoint</v-icon
                                >
                                <v-icon
                                  class="mt-5"
                                  size="50"
                                  color="purple"
                                  v-if="file.type.match('video.*')"
                                  >mdi-file-video</v-icon
                                >
                              </div>
                            </v-sheet>
                          </v-chip>
                          <p>
                            <small :title="file.name"
                              >{{
                                file.name.length > 30
                                  ? file.name.substr(0, 20) + "..."
                                  : file.name
                              }}
                            </small>
                          </p>
                        </div>
                      </v-row>
                      <v-text-field
                        v-model.trim="messageForm.content"
                        label="Escribe un mensaje"
                        type="text"
                        no-details
                        densed
                        append-outer-icon="mdi-send"
                        @keyup.enter="addMessage(messageForm.content,chatId)"
                        @click:append-outer="addMessage(messageForm.content,chatId)"
                        hide-details
                      />
                    </p>

                    <div class="box-container justify-center">
                      <span class="box color1-logo"></span>
                      <span class="box color2-logo"></span>
                      <span class="box color3-logo"></span>
                      <span class="box color4-logo"></span>
                      <span class="box color5-logo"></span>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-space-around">
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="hiddeAttachDialog()"
                      small
                    >
                      Cancelar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <input
                id="file-upload"
                type="file"
                v-on:change="addImageGroup()"
                ref="fileInputGroup"
                style="visibility: hidden"
              />
              <input
                id="file-upload"
                type="file"
                v-on:change="onFilesChange"
                ref="filesChat"
                style="visibility: hidden"
                multiple=""
              />
            </template>
          </v-row>
          <v-row v-else>
            <v-col>
              <h2>Selecciona un chat</h2>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogReasignar" max-width="400px">
        <v-card>
          <v-card-title>Reasignar operador</v-card-title>
          <v-card-text>¿Está seguro de reasignar el chat a este operador?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small  @click="reasignarChatOperador(selectedOperador.id)">Aceptar</v-btn>
            <v-btn color="grey darken-1" small dark  @click="cancelActionReasignar">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </CardIeaAppMain>
  </div>
</template>

<script>
  import CardIeaAppMain from "../../components/CardIeaAppMain";
  import SocketConnection from "itoeste-socket";
  import { DEBUG, API_SOCKET } from "../../../env";

  export default {
    components: {
      CardIeaAppMain,
    },
    data() {
      return {
        inactiveChats: [], // Cola para almacenar los chats inactivos
        currentInactiveChat: null, // Chat actualmente siendo procesado
        showInactiveModal: false,
        debug: DEBUG,
        buttonColor: 'green',
        isButtonPressed: false,
        nombreAlumno: undefined,
        autoMessageCounters: {}, 
        //autoMessageCounter: 0,
        chatFocused: undefined,
        textSearch: "",
        messageForm: {
          content: "",
          files: [],
        },
        limit: 10,
        showImageAttach: false,
        max_size_file: 30,
        sendingMessage: false,
        showMenu: true,
        showChatPanel: true,
        chats: [],
        selectedChat:null,
        chatId: null,
        allChatSelected: [],
        operadores: [],
        companeros: [],
        selectedOption: null,
        countTu: 0,
        countOtros: 0,
        countTodo: 0,
        selectedOperador: null,
        dialogReasignar: false,
        operadorEncontrado: null,
        textSearchContact:  null,
        operadorAlumnoTu: undefined,
        operadorAlumnoOtros: undefined,
        operadorAlumnoTodo: undefined,
        ws: SocketConnection(
          {
            debug: DEBUG,
            token: API_SOCKET,
          },
          () => {}
          ),
      };
    },
     mounted() {
       this.getChatsAlumno();
       this.getOperadores();
       this.startCheckTimeout();
       console.log('Operador alumno tu ')
      this.ws.subscribeChannel('operator-chats-all', (e) =>{
        console.log('RECIBIENDO EVENTO POR SOCKET NUEVO ', e.action);
        switch (e.action) {
          case "change-chats": 
            this.getChatsAlumno();
            this.getOperadores();
            break;
        }
       } );
      
      this.ws.subscribeChannel('operator-chats-' + this.$store.getters.user.IDStB , (e) =>{
        switch (e.action) {
          case "asignar-operador": this.playSound(); break;
          case "new-messages": break;
          case 'disconnected-operator': break;
          case 'litle-time-change-operator': this.playSound(); break;
        }
        this.getChatsAlumno();
       } );

       console.log('-------->')
      let url = 'op/materiaPlanEstudio/v2/materiasOptativas/11103?draw=1&columns%5B0%5D%5Bdata%5D=id&columns%5B0%5D%5Bname%5D=id&columns%5B0%5D%5Bsearchable%5D=true&columns%5B0%5D%5Borderable%5D=true&columns%5B0%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B0%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B1%5D%5Bdata%5D=materia&columns%5B1%5D%5Bname%5D=materia&columns%5B1%5D%5Bsearchable%5D=true&columns%5B1%5D%5Borderable%5D=true&columns%5B1%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B1%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B2%5D%5Bdata%5D=materia_asignada&columns%5B2%5D%5Bname%5D=materia_asignada&columns%5B2%5D%5Bsearchable%5D=true&columns%5B2%5D%5Borderable%5D=true&columns%5B2%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B2%5D%5Bsearch%5D%5Bregex%5D=false&order%5B0%5D%5Bcolumn%5D=0&order%5B0%5D%5Bdir%5D=asc&start=0&length=10&search%5Bvalue%5D=&search%5Bregex%5D=false&_=1709646118076';
      this.$API
      .get({
        url:url
      },false)
      .then((res)=>{
        console.log('------>', res)
      }).catch((err)=>{
        console.log('<-----------',err)
      })

    },
    computed: {
      selectedChatData() {
        // obtener conversacion de chat
        let chatList = this.getSelectedOptionChats();
        
        return this.selectedChat ? chatList.find(chat => chat.chatGptId === this.selectedChat) : null;
      },

      
    },
    methods: {
      pressButton() {
        this.isButtonPressed = true;
      },
      releaseButton() {
        this.isButtonPressed = false;
      },

      darkenIcon() {
        document.getElementById('powerButton').style.borderColor = 'rgba(0, 0, 0, 0.5)';
      },
      lightenIcon() {
        document.getElementById('powerButton').style.borderColor = 'transparent';
      },

      toggleColor() {
        this.buttonColor = this.buttonColor === 'green' ? 'red' : 'green';
        return this.buttonColor;
      },
      
      async operatorStatus(){
        const colorOption = this.toggleColor();
        
        await this.$API.post({ url: "operator-status", data: {
          id: this.$store.getters.user.IDStB, 
          disabled: colorOption=='green' ? false : true
        }}, false)
        .then(res => console.log('exitoso : --------', res));
      },
      
      
      getType_(file) {
        let alloweds = [
          { t: "pdf", c: "red" },
          { t: "word", c: "blue" },
          { t: "image", c: null },
          { t: "video", c: "purple" },
          { t: "excel", c: "green" },
          { t: "presentation", c: "orange" },
        ];
        let type = null;
        alloweds.forEach((allowed) => {
          if (file.type.match(allowed.t + ".*")) {
            type = allowed;
          }
        });
        return type;
      },

      getType(file) {
        let alloweds = ["pdf", "word", "image", "video", "excel", "presentation"];
        let type = "";
        alloweds.forEach((mime) => {
          if (file.type.match(mime + ".*")) {
            type = mime;
          }
        });
        return type;
      },  

      addImageGroup() {
        let val = this.$refs.fileInputGroup.files[0];
        if (val.type.match("image.*")) {
          val.url = URL.createObjectURL(val);
          this.chatActive.image = val.url;
        }
      },

      deleteFileChatThumnail(index) {
        this.messageForm.files.splice(index, 1);
      },

      hiddeAttachDialog() {
        this.showImageAttach = false;
        this.messageForm.files = [];
      },

      isAllowed(file) {
        let alloweds = ["pdf", "word", "image", "video", "excel", "presentation"];
        let allowed = false;
        alloweds.forEach((mime) => {
          if (file.type.match(mime + ".*")) {
            allowed = true;
          }
        });
        return allowed;
      },

      hasAllowedSize(file) {
        let allowed = false;
        let limit = this.max_size_file * 1024 * 1024;
        if (file.size <= limit) {
          allowed = true;
        }
        return allowed;
      },

      async attachFile() {
        this.$refs.filesChat.click();
      },

      onFilesChange(e) {
        
        let all = [...e.target.files];
        
        if (all.length > 0) {
          all.forEach((val) => {
            if (this.messageForm.files.length < this.limit) {
              if(val.type.match('image.*')|| val.type.match('pdf.*') || val.type.match('word.*') || val.type.match('video.*')|| val.type.match('excel.*')|| val.type.match('presentation.*')){
              val.url = URL.createObjectURL(val);
                if (this.isAllowed(val) && this.hasAllowedSize(val)) {
                  this.messageForm.files.push(val);
                  console.log('ARCHIVOOOOOOOO',this.messageForm.files)
              }}
            }
          });
          if (this.messageForm.files.length > 0) {
            this.showImageAttach = true;
          } else {
            this.showAlert = true;
            this.contentAlert = "Imposible enviar esos archivos";
            this.typeAlert = "modal-danger";
          }
        }

      },

      playSound() { 
        const audio = new Audio( require("@/assets/notification.mp3") );
        audio.play();
      },

      onReceiveMessage(data) {
        if (this.$store.getters.user.id != data.user_id) {
          this.playSound();
        }
        if(this.chatFocused && this.selectedChat) {
          let url = "operadores/messages/" + this.selectedChat;
          this.$API
          .get({
            url: url
          },
          false
        ).then((res) => {
          //Inactividad revisar
          console.log('CAMPOS Y COSAS QUE TRAE EL OPERADOR',res.response)
          console.log('ESTO ES EL ENDPOINT CON THIS.SELECTEDCHAT-->', this.selectedChat)
            this.allChatSelected = res.response;
            this.scroll() });
        }
  
      },
      onDeleteMessage(data) {
        console.log(data)
      },

      onDisconect() {
        this.$API.post({ url: "chatgpt/liberar-operador", data: {id: this.alumnoId} }, false)
          .then(res => console.log('exitoso : --------', res));
      },
      sendMessage(chatId, message, autoMessage) {
        console.log('El mensaje es: ', message);
        this.sendingMessage = true;
        if (message) {
          var formData = new FormData();

          if (this.messageForm.files.length > 0) {
            this.messageForm.files.forEach(file => {
              formData.append("file", file);
              formData.append("type", this.getType(file));
            });
          }
          formData.append("userMessage", message);

          this.$API.post(
            {
              url: "operadores/messages/" + this.selectedChat,
              data: formData
            },
            false
          )
          .then(() => {
            console.log('exitoso');
            //this.ws.sendMessage(res)
            //this.ws.chatAction('message-new', res)
            this.messageForm.content = "";
            this.tab = 0;
            this.sendingMessage = false;
            this.messageForm.files = [];
            this.messageResend = null;
            if (autoMessage) this.getChatsAlumno();
          });
        }
        this.showImageAttach = false;
      },      

      addMessage(content, chatActiveId, autoMessage) {   
        console.log('Esto es en addmessage y los datos respectivos content y chatActiveId ', content, chatActiveId)  
        if (content) {
          if (chatActiveId) {
            this.sendMessage(chatActiveId, content, autoMessage);
    
          }
        }
      },


      getSelectedOptionChats() {
        // opciones del menu lateral
        switch (this.selectedOption) {
          case 1:
            return this.operadorAlumnoTu;
          case 2:
            return this.operadorAlumnoOtros;
          case 3:
            return this.operadorAlumnoTodo;
          case 4:
            return this.chatsCompanero;
            default:
              return [];
            }
          },
      getChatsAlumno() {
        let url = "operadores/index-alumnos";
        this.$API
          .get({
            url: url
          },
          false
          ).then((res) => {
            this.operadorAlumnoTodo = res.operadorAlumnoTodo;
            this.operadorAlumnoTu = res.operadorAlumnoTu;
            this.buttonColor = res.Disponible == 1 ? 'green' : 'red';
            this.tiempoInac = res.Tiempo_de_inactividad;
            this.operadorAlumnoOtros = res.operadorAlumnoOtros;
            this.countTodo = res.TotalAsignacionesTodo;
            this.countTu = res.TotalAsignacionesTu; 
            this.countOtros = res.TotalAsignacionesOtros;
            console.log('TONOTOS TONOTOS TONOTOS', res);
          });
      },
      checkMessages() {
        const threeMinutes = this.tiempoInac; // En minutos
        const currentTime = new Date().getTime() / 60000;

        const updateChatStatus = (chat) => {
            const fechaUltimoMensaje = new Date(chat.fechaUltimoMensaje).getTime() / 60000;
            const timeDifference = currentTime - fechaUltimoMensaje;

            if (timeDifference > threeMinutes) {
                chat.inactivo = true;
                const hoursInactive = Math.floor(timeDifference / 60);
                chat.inactiveMessage = `Inactivo hace más de ${hoursInactive} hora(s)`;
            } else {
                chat.inactivo = false;
                chat.inactiveMessage = null;
            }
        };

        const selectedChats = this.getSelectedOptionChats();

        selectedChats.forEach(updateChatStatus);

        this.$forceUpdate();
    },

      startCheckTimeout() {
          setInterval(() => {
              this.checkMessages();
          }, 1000);
      },




      processNextInactiveChat() {
        if (this.inactiveChats.length > 0) {
          this.currentInactiveChat = this.inactiveChats.shift();
          this.showInactiveModal = true;
        } else {
          this.currentInactiveChat = null;
        }
      },
      handleYes() {
        if (this.currentInactiveChat) {
          console.log(`Finalizando la conversación con el chat ID: ${this.currentInactiveChat}`);
          this.alumnoId = this.currentInactiveChat;
          this.onDisconect(this.alumnoId);
          this.showInactiveModal = false;
          this.processNextInactiveChat();
        }
      },
      handleNo() {
        this.showInactiveModal = false;
        this.processNextInactiveChat();
      },

      selectMenuItem(option) {
        this.selectedOption = option;
      },
      toggleChatPanel() {
        this.showChatPanel = !this.showChatPanel;
      },
      getSelectedChat(chat, ifView) {

        this.selectedChat = chat?.chatGptId;
        this.chatId = chat?.chatGptId;
        this.alumnoId = chat?.alumnoId;
        if(ifView) {
          this.$API
            .post({ url: "operadores/view-message/" + chat?.chatGptId },
            false
          )

          this.getChatsAlumno();
        }
        console.log('ESTO ES EL ENDPOINT CON CHAT?.CHATGPTID-->', chat?.chatGptId)
        let url = "operadores/messages/" + chat?.chatGptId;
        this.$API
        .get({
          url: url
        },
        false
        ).then((res) => {
          this.allChatSelected = res.response;
          this.nombreAlumno = res.alumnoActual.Nombres;
          
          this.scroll()
          


          this.ws.subscribeChannel("chat-operador-" + this.alumnoId, (result) => {
            console.log("Recibiendo evento por socket CHAT OPERADOR", this.alumnoId);
            console.log(result);
            switch (result.action) {
              case "message-new":
                console.log('contenido de message new  comnchales', result)
                this.onReceiveMessage(JSON.parse(result.message));
                this.getChatsAlumno();
                break;
              case "message-delete":
                //Alquien acaba de abandonar un chat
                this.onDeleteMessage(result);
                break;
              case "close-mode-operator":
                //El operador mandó a desconectar
                this.getChatsAlumno();
                this.getOperadores();
                this.selectedOption = null;
                break
            }
          });
        });
        if (chat.operator_response === 0 && (chat.operador_id == this.$store.getters.user.IDStB) ) {
          this.addMessage(`Hola, un gusto. Te saluda ${this.$store.getters.user.Nombres}`, chat.chatGptId, true);
        }       
      },
      scroll() {
        this.$nextTick(() => {
          const allChatSelected = this.$refs.allChatSelected;
          allChatSelected.scrollTo({
            top: allChatSelected.scrollHeight,
            behavior: 'auto'
          });
        });
      },
      getOperadores() {
        let url = "operadores";
        this.$API
          .get({
            url: url
          }, false)
          .then((res) => {
            this.operadores = [{ id: 0, nombre: 'ChatGPT' }, ...res.response];
            this.companeros = res.response;
            this.operadoresDisponibles = res.response.filter(operador => operador.disponible === 1);
          })
          .catch((error) => {
            console.error('Error fetching operadores:', error);
          });
      },

      getChatsCompanero(companero_id) {
        this.selectMenuItem()

        let url = "operadores/chats-companero/" + companero_id;
         this.$API
        .get({
          url: url
        },
        false
        ).then((res) => {
          this.chatsCompanero = res.response; 
          this.selectMenuItem(4)
        });
      },
      reasignarChatOperador(nuevoOperadorId){

        let chatgptId = this.selectedChat;

        this.dialogReasignar = true;

        let url = "operadores/reasignar-operador/" + nuevoOperadorId;
        this.$API
        .post({
          url: url,
          data: {
            chatgptId
          }
        }).then(() => {
          this.dialogReasignar = false;
          this.selectedOperador = null;
        })
      },
      cancelActionReasignar() {
        this.dialogReasignar = false;
      },
      searchOperadores() {
        this.operadorEncontrado = null;
        let url = `operadores/search?search=${this.textSearchContact}`;
        
        this.$API
          .get({
            url: url, 
          },
          false
          ).then((res) => { 
            this.operadorEncontrado = res.response; 
          });
      },
    },
    watch: {
      selectedOption() {
        this.selectedChat = null;
        this.chatId = null;
        this.alumnoId = null;
      },
    },
  };
  //Ramon antonio gomez@istitutoeia.edu.ae usuario de Denis
</script>
